import { Layer } from '~/packages/variable/spaceTime.types'
import { RightButtonsTopBoxProps } from '~/packages/sentinel/rightButtonsTopBox.component'
import RightButtons from '~/packages/sentinel/rightButtons.component'
import ViewSelect, { type LayerCacheStatus } from '~/packages/sentinel/viewSelect.component'
import { ReportWithLayer } from '~/packages/sentinel/reports'
import { attributionMarginLeftPx } from '../map/map'
import styled from 'styled-components'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const WrapperBottomButtons = styled.div`
  position: absolute;
  top: 0px;
  right: 0.6rem;
  bottom: ${attributionMarginLeftPx}px;
  left: 0.6rem;

  display: flex;
  justify-content: space-between;
  align-items: end;

  gap: 0.3rem;
  padding-bottom: 0.3rem;
  pointer-events: none;

  > * {
    pointer-events: all;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-direction: column;
    justify-content: end;
    align-items: start;
    bottom: 4px;
  }
`

const ReopenInsightsWrapper = styled.aside`
  position: absolute;
  top: 0.6rem;
  right: calc(0.6rem + 40px + 5px);

  display: flex;
  align-items: center;
  justify-content: center;

  height: 40px;
  width: 40px;

  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadow(1)};

  background-color: white;

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: ${({ theme }) => theme.backdropBackground};
    -webkit-backdrop-filter: ${({ theme }) => theme.backdropFilter};
    backdrop-filter: ${({ theme }) => theme.backdropFilter};
  }

  cursor: pointer;
`

interface ViewSelectProps {
  baseLayers: Layer[]
  onChangeReport: (report: ReportWithLayer | null) => void
  subtitle?: string | null
}

export const BaseControls = ({
  onChangeMapType,
  mapType,
  onChangeMap3DOption,
  map3DOption,
  layers,
  variables,
  setBaseLayers,
  styles,
  stateId,
  stateName,
  baseLayers,
  onChangeReport,
  subtitle,
  children,
  isDisabled = false,
  isInsightsModalOpen,
  setIsSomethingLoading,
  onOpenInsightsModal,
  isReadyForSentinelUI,
  layerCacheStatuses,
}: RightButtonsTopBoxProps &
  ViewSelectProps & {
    children: React.ReactNode
    isDisabled?: boolean
    isInsightsModalOpen: boolean
    stateId: number | null
    stateName: string | null
    setIsSomethingLoading?: (isLoading: boolean) => void
    onOpenInsightsModal: () => void
    isReadyForSentinelUI: boolean
    layerCacheStatuses?: LayerCacheStatus[]
  }) => {
  return (
    <>
      {!isInsightsModalOpen && isReadyForSentinelUI && (
        <>
          <RightButtons
            onChangeMapType={onChangeMapType}
            mapType={mapType}
            onChangeMap3DOption={onChangeMap3DOption}
            map3DOption={map3DOption}
            layers={layers}
            baseLayers={baseLayers}
            variables={variables}
            setBaseLayers={setBaseLayers}
            styles={styles}
            setIsSomethingLoading={setIsSomethingLoading}
          />
          <ReopenInsightsWrapper title='Abrir insights' onClick={onOpenInsightsModal}>
            <FontAwesomeIcon icon={faLightbulb} size='lg' />
          </ReopenInsightsWrapper>
        </>
      )}
      <ViewSelect
        variables={variables}
        layers={layers}
        baseLayers={baseLayers}
        setBaseLayers={setBaseLayers}
        onChangeReport={onChangeReport}
        stateId={stateId}
        stateName={stateName}
        subtitle={subtitle}
        isDisabled={isDisabled}
        layerCacheStatuses={layerCacheStatuses}
      />

      <WrapperBottomButtons>{children}</WrapperBottomButtons>
    </>
  )
}
